import api from '../../api'

export type OrphanedRouteEventsCleanupResult = {
  deletedCount: number
}

export const cleanupOrphanedRouteEvents = async (): Promise<OrphanedRouteEventsCleanupResult> => {
  return (await api.post('/web/admin/orphaned-route-events/cleanup')).data
}
